import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

const StyledButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'buttonVariant',
})(({ buttonVariant }) => ({
  height: '36px',
  padding: '10px',
  borderRadius: '4px',
  fontSize: '15px',
  fontWeight: 600,
  boxShadow: 'none',
  textTransform: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  // 필터 영역의 메인 검색 버튼 (긴 teal).
  ...(buttonVariant === 'primary' && {
    width: '200px',
    backgroundColor: '#58B9C1',
    color: '#fff',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#58B9C1',
    },
  }),
  // 필터 초기화 버튼 (회색).
  ...(buttonVariant === 'secondary' && {
    width: '140px',
    backgroundColor: '#D9D9D9',
    color: '#262626',
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: '#C9C9C9',
    },
  }),
}));

const CommonFilterActionButton = ({ variant = 'primary', children, ...rest }) => (
  <StyledButton buttonVariant={variant} variant="contained" {...rest}>
    {children}
  </StyledButton>
);

export default CommonFilterActionButton;
